export default __webpack_public_path__ + "static/media/IMG_2209.36a484bd.JPG";